<template>
	<div>
		<div class="ft20 cl-main ftw600">卡片管理</div>
		
		<div class="mt20">
			<div class="form-search-box ">
				<a-form layout="inline">
					<a-form-item label="卡片名称">
						<a-input v-model="search.name" placeholder="请输入卡片名称"></a-input>
					</a-form-item>

					<a-form-item label="卡片类型">
						<div>
							<a-select style="width: 120px" placeholder="全部" v-model="search.type">
								<a-select-option :value="0">全部</a-select-option>
								<a-select-option :value="item.value" :key="index" v-for="(item,index) in types">{{item.name}}</a-select-option>
							</a-select>
						</div>
					</a-form-item>
			
					<a-form-item>
						<a-button @click="searchAct" type="primary">查询</a-button>
						<a-button @click="cancelAct" class="ml10">取消</a-button>
					</a-form-item>
				</a-form>
			</div>
		</div>
		
		<div class="mt20">
			<div class="pd30 bg-w " style="min-height: 800px;">
					<div>
						<a-button type="primary" icon="plus" @click="addSnapUpAct()">添加卡片</a-button>
					</div>
					
					<div class="mt20 flex alcenter">
						<a-radio-group v-model="search.status" button-style="solid" @change="changeStatus">
							<a-radio-button :value="1">
							  上架中
							</a-radio-button>
							<a-radio-button :value="-1">
							  已下架
							</a-radio-button>
						</a-radio-group>
						
						<!-- <div class="ml40 flex alcenter">
							<div>是否秒杀</div>
							
							<a-radio-group name="radioGroup" class="ml15" v-model="search.is_flash_sale" @change="changeFlash">
							    <a-radio :value="1">
							      是
							    </a-radio>
							    <a-radio :value="0">
							      否
							    </a-radio>
							</a-radio-group>
						</div> -->
					</div>
					
					<div class=" mt20">
						<div class="wxb-table-gray">
							<a-table rowKey="once_card_id" :columns="columns" :pagination="pagination" @change="handleTableChange"
								:data-source="datas" :loading="loading">
								
								<div  slot="oncecard" slot-scope="record">
									<div class="flex alcenter center" >
										<img :src="record.cover_img"  class="projetc-index-cover-img" />
										<div class="ml5" style="text-align: left;">
											<div class="text-name">{{record.name}}</div>
											<div v-if="record.type==1" class="text-info">到账金额：￥{{record.worth}}</div>
											<div v-if="record.type==1" class="text-info">下单折扣：{{ Number(record.discount * 10) }}折</div>
											<div v-if="record.type==3" class="text-info">使用次数：{{record.use_num}}</div>
										</div>
									</div>
								</div>

								<div class="flex alcenter center" slot="type_slot" slot-scope="type,record">
									<div v-if="type == 1">充值卡</div>
									<div v-if="type == 2">项目卡</div>
									<div v-if="type == 3">活动卡</div>
								</div>

								<div  slot="flash_sale" slot-scope="record">
									<div class="flex alcenter " v-if="record.is_flash_sale==1 && record.is_flash_sale_expire==0">
										<div class="once-card-flash-sale-tag ft14 ftw400 cl-w" style="background: #FF6600;">秒杀</div>
										<div class="ml10 ft14 ftw400 cl-black">秒杀价 ¥{{record.flash_price}}</div>
									</div>
									<div class="flex alcenter " v-else>
										<div class="once-card-flash-sale-tag ft14 ftw400 cl-w" style="background: #DCDFE6;">秒杀</div>
									</div>
								</div>
								
								<div class="flex alcenter center" slot="price" slot-scope="price,record">
									¥{{price}}
								</div>

								<div class="flex alcenter center" slot="worth_slot" slot-scope="worth,record">
									¥{{worth}}
								</div>

								<div class="flex alcenter center" slot="discount_slot" slot-scope="discount,record">
									{{ Number(discount * 10) }}折
								</div>
								
								<div class="flex alcenter center" slot="items_count" slot-scope="items_count,record">
									{{items_count}}个
								</div>
			
								<template slot="action" slot-scope="record,index">
									<div class="flex center">
										<a-dropdown placement="bottomRight">
											<span class="more-act">
												<i class="iconfont iconmore_gray"></i>
											</span>
											<a-menu slot="overlay">
												<a-menu-item>
													<a class="menu-act" href="javascript:;" @click="editSnapUpAct(record)">
														<i class="iconfont ft14 iconedit"></i>
														<span class="ml10">编辑</span>
													</a>
												</a-menu-item>
												<a-menu-item v-if="record.status==1">
													<a class="menu-act" href="javascript:;" @click="undercarriage(record)">
														<i class="iconfont ft14 iconxiajia"></i>
														<span class="ml10">下架</span>
													</a>
												</a-menu-item>
												<a-menu-item v-if="record.status==-1">
													<a class="menu-act" href="javascript:;" @click="grounding(record)">
														<i class="iconfont ft14 iconshangjia"></i>
														<span class="ml10">上架</span>
													</a>
												</a-menu-item>
												<a-menu-item v-if="record.status==-1">
													<a class="menu-act" href="javascript:;" @click="del(record)"> 
														<i class="iconfont ft14 icondelete"></i>
														<span class="ml10">删除</span>
													</a>
												</a-menu-item>
			
											</a-menu>
										</a-dropdown>
									</div>
								</template>
							</a-table>
						</div>
					</div>
				</div>
			
		</div>
	</div>
</template>

<script>
	import {listMixin} from '../../common/mixin/list.js';
	export default{
		mixins: [listMixin],
		data(){
			return{
				loading: false,
				pagination: {
					current: 1,
					pageSize: 10, //每页中显示10条数据
					total: 0,
				},
				search:{
					name:'',
					status:1,
					is_flash_sale:0,
					type:0,
				},
				columns: [
					
					{title: '编号',dataIndex: 'once_card_id',align: 'center'},
					{title: '卡片',key: 'oncecard',align: 'center',width:300,scopedSlots: {customRender: 'oncecard'}},
					{title: '类型',dataIndex: 'type',align: 'center',width:120,scopedSlots: {customRender: 'type_slot'}},
					// {title: '是否秒杀',key: 'flash_sale',align: 'center',width: 200,scopedSlots: {customRender: 'flash_sale'}},
					{title: '售价',dataIndex: 'price',align: 'center',scopedSlots: {customRender: 'price'}},
					//{title: '到账金额',dataIndex: 'worth',align: 'center',scopedSlots: {customRender: 'worth_slot'}},
					//{title: '下单折扣',dataIndex: 'discount',align: 'center',scopedSlots: {customRender: 'discount_slot'}},
					{title: '已售',dataIndex: 'take_count',align: 'center',ellipsis: true},
					{title: '关联项目',dataIndex: 'items_count',align: 'center',scopedSlots: {customRender: 'items_count'}},
					{title: '排序',dataIndex: 'sort',align: 'center',ellipsis: true},
					{title: '创建时间',dataIndex: 'add_time_format',align: 'center',ellipsis: true,width:200},
					{title: '操作',key: 'action',align: 'center',scopedSlots: {customRender: 'action'}}
				],
				datas: [],
				types:[
					{value:1, name:'充值卡'},
					// {value:2, name:'项目卡'},
					{value:3, name:'活动卡'}
				]
			}
		},
		methods:{
			getLists() {
				if (this.loading == true) return;
				this.loading = true;
				this.$http.api('admin/getOncecardList', {
					limit: this.pagination.pageSize,
					page: this.pagination.current,
					name: this.search.name,
					status: this.search.status,
					is_flash_sale: this.search.is_flash_sale,
					type: this.search.type
				}).then(res => {
					this.pagination.total = res.total;
					this.datas = res.list;
					this.loading = false;
				}).catch(res => {
					this.loading = false;
				})
			},
			
			undercarriage(record){
				this.$confirm({
					title:'确认下架这个卡片吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('admin/undercarriageOncecard',{
								once_card_id:record.once_card_id,
							}).then(res=>{
								this.$message.success('下架成功');
								this.getLists();
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
			
			grounding(record){
				this.$confirm({
					title:'确认上架这个卡片吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('admin/groundingOncecard',{
								once_card_id:record.once_card_id,
							}).then(res=>{
								this.$message.success('上架成功');
								this.getLists();
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
			
			del(record){
				this.$confirm({
					title:'确认删除这个卡片吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('admin/delOncecard',{
								once_card_id:record.once_card_id,
							}).then(res=>{
								this.$message.success('删除成功');
								this.getLists();
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
			
			changeFlash(){
				this.pagination.current=1;
				this.getLists();
			},
			
			addSnapUpAct(){
				this.$router.push('/project/oncecard/edit');
			},
			editSnapUpAct(record){
				this.$router.push('/project/oncecard/edit?id='+record.once_card_id);
			},
			
			changeStatus(){
				this.pagination.current=1;
				this.getLists();
			},
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current;
				this.getLists();
			},
		}
	}
</script>

<style>
	.projetc-index-cover-img{
		width: 80px;
		height: 60px;
	}
	
	.once-card-flash-sale-tag{
		width: 40px;
		height: 20px;
		border-radius: 3px;
	}

	.text-name{
		font-size: 18px;
		margin-bottom: 5px;
	}

	.text-info{
		font-size: 14px;
	}
</style>
